import {
  ContentTypeEnum,
  BackgroundColorEnum,
} from '../../constants/cms-constants';
import RelatedPagesGridComponent from '../../components/RelatedPagesGrid';
import { BlockInstanceProps } from '../Block';
import {
  ComponentWithControlOptions,
  ControlOption,
} from '../../utils/controlOptions/ControlOptionDecorator';
import controlOptionDefinitions from '../../utils/controlOptions/controlOptionDefinitions';

@ControlOption([
  {
    key: 'backgroundColor',
    definition: controlOptionDefinitions.backgroundColor,
  },
  {
    key: 'seoWeight',
    definition: controlOptionDefinitions.SEOWeightTypes,
  },
])
class RelatedPagesGridBlock extends ComponentWithControlOptions<BlockInstanceProps> {
  render() {
    const { blockContent, block } = this.props;
    const controlOptions = block?.controlOptionsV2;
    const backgroundColor =
      BackgroundColorEnum[controlOptions?.backgroundColor];
    const seoWeight = controlOptions?.seoWeight;

    let items;
    blockContent.doQuery((content) => {
      items = content.getAllOfType(ContentTypeEnum.MEDIAITEM);
    });

    return (
      <RelatedPagesGridComponent
        headerText={block?.header?.main}
        backgroundColor={backgroundColor}
        mediaItems={items}
        seoWeight={seoWeight}
      />
    );
  }
}

export default RelatedPagesGridBlock;
